module.exports = __webpack_public_path__ + "static/img/bianjie.46c976f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/bianjie.png
// module id = lIsD
// module chunks = 70